
function ReruitPage(){
    return(
        <div className="test">
            <h1>채용</h1>
        </div>
    );
}

export default ReruitPage;